import { useEffect } from 'react'
import { atom, useAtom } from 'jotai'
import { atomFamily } from 'jotai/utils'
import { setupForm } from '@/services/PriceCalculator/PriceCalculator.helpers'
import type { PriceTemplate } from '@/services/PriceCalculator/PriceCalculator.types'
import { type PriceIntent } from '@/services/priceIntent/priceIntent.types'
import { usePriceTemplate } from './PurchaseForm/priceTemplateAtom'
import { usePriceIntentValueOrThrow } from './usePriceIntent'
import { useShopSessionCustomer } from './useShopSessionCustomer'

export const useRegistrationAddressAtomFamily = atomFamily((_priceIntentId: string) => atom(true))

export const useRegistrationAddressState = (priceIntentId: string) => {
  return useAtom(useRegistrationAddressAtomFamily(priceIntentId))
}

export const usePriceCalculatorForm = () => {
  const priceIntent = usePriceIntentValueOrThrow()
  const template = usePriceTemplate()
  const customer = useShopSessionCustomer()
  const prefillAddress = useShouldPrefillAddress(priceIntent, template)

  const form = setupForm({
    customer,
    priceIntent,
    template,
    prefillAddress,
  })

  return form
}

function useShouldPrefillAddress(priceIntent: PriceIntent, template: PriceTemplate) {
  const [useRegistrationAddress, setUseRegistrationAddress] = useRegistrationAddressState(priceIntent.id)

  useEffect(() => {
    if (template.prefillAddress === false) {
      setUseRegistrationAddress(false)
    } else {
      // containsSuggestedData is the server-side canonical signal for whether the
      // registration address was applied. Default to true when not yet set.
      setUseRegistrationAddress(priceIntent.data.containsSuggestedData !== false)
    }
  }, [priceIntent.id, priceIntent.data, template, setUseRegistrationAddress])

  return useRegistrationAddress
}
